var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDepartment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8.29 6.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#666;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ALL_-_ICONS",
    "data-name": "ALL - ICONS"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5.52.35V1H2.76V.35H5.52m0-.35H2.76a.34.34,0,0,0-.34.35v1H5.87v-1A.35.35,0,0,0,5.52,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2.76,
    y: 3.45,
    width: 2.76,
    height: 0.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 3.8,
    y: 2.42,
    width: 0.69,
    height: 2.76
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.69,
    y: 1.73,
    width: 0.35,
    height: 4.49
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M7.59,1H.69A.69.69,0,0,0,0,1.73V6.21a.69.69,0,0,0,.69.7h6.9a.7.7,0,0,0,.7-.7V1.73A.69.69,0,0,0,7.59,1Zm.35,5.17a.35.35,0,0,1-.35.35H.69a.35.35,0,0,1-.34-.35V1.73a.35.35,0,0,1,.34-.35h6.9a.35.35,0,0,1,.35.35Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 7.25,
    y: 1.73,
    width: 0.35,
    height: 4.49
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepartment);
export default __webpack_public_path__ + "static/media/department.3f26e06fe93a0175489d15418d2ce080.svg";
export { ForwardRef as ReactComponent };